import { useEffect, useState } from "react";
import { IAccountDetails } from "../interface/IOffer";
import { GET_ACCOUNT_LIST_ROUTE } from "@api-routes/accounts";
import { getResponseToState, IAccountListResponse } from "../mappers/getAccountDetailsMapper";
import { useFetch } from "@common/hook/useFetch";

export const useGetAccountDetails = () => {
    const [accountDetails, setAccountDetails] = useState<IAccountDetails>();
    const [accountDetailsState, { get }] = useFetch();

    useEffect(() => {
        get<IAccountListResponse>(GET_ACCOUNT_LIST_ROUTE).then((accountListResponse) => {
            if (accountListResponse) {
                setAccountDetails(getResponseToState(accountListResponse));
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { accountDetails, accountDetailsState };
};
